import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as ko from "knockout";
import {Application} from "../application";

export class HideEstimateComponentCostsCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.HideEstimateComponentCosts;

    canExecute = ko.computed(() => {
        return !!this.app.state.estimate();
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(): JQueryPromise<any> {
        let dfd = $.Deferred();

        if (!this.canExecute())
            return dfd.reject().promise();

        this.app.state.estimateGridHideComponentCosts(!this.app.state.estimateGridHideComponentCosts());
        
        return dfd.resolve().promise();
    }
    
    name = "Hide Estimate Component Costs"
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/hideEstimateComponentCosts.ts